import React from 'react';

import AOS from 'aos';
import 'aos/dist/aos.css';

import Form from './Form';

import BgVd1 from "./../Images/bg1.gif";

AOS.init({
    duration: 1200
});

export default function CallAction2() {
    return (
        <div className='call-cont2 fix p-rel'>
            <div className='video-bg1'><img src={BgVd1} alt='' /></div>
            <div className='container-fluid sectin'>
                <div className='row'>
                    <div className='col-lg-10 col-18 ca-lt-ct mb-0'>
                        <div><h2 className='h1 fw-300 mb-8' data-aos="fade-down" data-aos-once='true'><span>let's discuss your</span><span className='cta-title2'>next <span className='right-arrow2'></span> success story</span></h2></div>
                        <div className='mxw-450'><p className='f-20 mb-8 line-ht-24' data-aos="fade-up" data-aos-once='true' data-aos-delay="400">Share your vision with us — together, we'll craft a path to growth and impact.</p></div>
                    </div>
                    <div className='col-lg-8 col-18 ca-rt-ct mb-0'>
                        <div className='mxw-400 m-auto' data-aos="fade-left" data-aos-once='true' data-aos-delay="600"><Form /></div>
                    </div>
                </div>
            </div>
        </div >
    )
}
